// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"125":"627e15a4","825":"b36d05d0"}[chunkId] + ".chunk.css";
};